import { render, staticRenderFns } from "./plan2030.vue?vue&type=template&id=3ba5de93&scoped=true"
import script from "./plan2030.vue?vue&type=script&lang=js"
export * from "./plan2030.vue?vue&type=script&lang=js"
import style0 from "./plan2030.vue?vue&type=style&index=0&id=3ba5de93&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba5de93",
  null
  
)

export default component.exports